<app-loader-v1 *ngIf="showLoadingIndicator"></app-loader-v1>



<form *ngIf="campus" [formGroup]="campusFormGroup" class="editForm" novalidate>

  <div class="row">
    <div class="col-lg-12">
      <div class="card card-primary">
        <div class="card-header text-uppercase"> CHOOSE CAMPUS NOTE: CAMPUS CAN NOT BE CHANGE AFTER YOU SAVE AND
          CONTINUE </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  Choose Entry Type
                  <small class="text-danger">(required)</small>

                </label>
                <select formControlName="EntryTypeId" class="form-control">
                  <option value="">SELECT entry type</option>
                  <option *ngFor="let item of entryTypes" value="{{item.Id}}">
                    {{item.Name}}

                </select>
              </div>
            </div>


          </div>

          <div class="row">
            <div class="col-md-6" *ngIf="!campusSelected">
              <div class="form-group">
                <label>
                  Select Campus <small class="text-muted">(required)</small>
                </label>
                <select formControlName="CampusId" class="form-control" (change)="onCampusChanged($event)">
                  <option value="">Select Campus</option>
                  <option *ngFor="let item of campus" value="{{item.ValueId}}">
                    {{item.DisplayValue}}
                  </option>

                </select>



              </div>


            </div>
            <div class="col-md-6" *ngIf="campusSelected">
              <div class="form-group">
                <label class="text-danger">Note: All your selected programmes will be cleared after changing the campus
                </label>
                <h5 class="text-danger">NB: Changed campus will be updated after selecting your programmes</h5>
                <button class="btn btn-primary waves-effect waves-light m-1 float-left" (click)="onChangeCampus()">Click
                  to Change Campus</button>
              </div>


            </div>
          </div>


          <div class="col-md-12" *ngIf="!campusSelected">
            <h5 class="form-header  text-uppercase text-danger">NOTE: CAMPUS CAN NOT BE CHANGED AFTER YOU SAVE AND
              CONTINUE. </h5>
          </div>




          <div class="col-md-12" *ngIf="campusSelected">
            <h5 class="form-header text-uppercase text-success">APPLICANT SELECTED CAMPUS: {{campusData.Campus}}</h5>
          </div>

          <div class="table-responsive" *ngIf="programmes">
            <h6 class="form-header text-uppercase text-success">PROGRAMMES AVAILABLE</h6>

            <table class="table">
              <thead class="thead-primary">
                <tr>
                  <th>Programme</th>
                  <th>Faculty</th>
                  <th>Fees Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of programmes; let i=index">
                  <td>{{item.ProgrammeFullName}}</td>
                  <td>{{item.FacultyCode}}</td>


                  <td *ngIf="item.IsFeePaying">
                    Fee Paying
                  </td>
                  <td *ngIf="!item.IsFeePaying">
                    Regular
                  </td>



                </tr>



              </tbody>
            </table>
          </div>

        </div>
        <div class="form-footer">
          <div class="form-group text-center">
            <button class="btn btn-default waves-effect waves-light m-1 float-left"
              (click)="goToPrevious(campusFormGroup)"><i class="fa fa-backward"></i> Go Back</button>
            <button class="btn btn-primary waves-effect waves-light m-1 float-right" id="next"
              [disabled]="!campusFormGroup.valid" (click)="goToNext(campusFormGroup)">{{continueButtonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>







</form>